import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'Util/refluxConnector';
import { mixin, RefluxMixin } from 'Util';
import { translate as _l } from 'oxygen-i18n';
import { Units } from 'Css';
import { List, Toggle, TextField } from 'material-ui';
import { CourseActions, DashboardActions } from 'actions';
import debounce from 'oxygen-debounce';
import { CourseStore } from 'stores';
import moment from 'moment'

addTranslations({
  ['en-US']: {
    'Quiz settings': 'Quiz settings',
    'Quiz page settings': 'Quiz settings for: ',
    'Enable quiz': 'Enable quiz',
    'Enable timer': 'Set timer on quiz',
    startDate: 'Start date',
    endDate: 'End date',
    'QuizWarning': 'Doing this will delete all the questions you have created',
    Repeatable: 'Allow users to retake the test',
    Hide: 'Hide answers when user completes test',
    'Score to pass the test': 'Score to pass the test',
    'Welcome message': 'Welcome message',
    'Success message': 'Success message',
    'Fail message': 'Fail message',
    threshold: 'Limit to pass the quiz (%)',
    Description: 'Description',
    timerInfo: 'Set timer in format HH:MM:SS'
  },
  ['sv-SE']: {
    'Quiz settings': 'Quiz inställningar',
    'Quiz page settings': 'Quiz inställningar för: ',
    'Enable quiz': 'Aktivera quiz',
    'Enable timer': 'Ställ in timer på frågesport',
    startDate: 'Start datum',
    endDate: 'Slut datum',
    'QuizWarning': 'Det här kommer ta bort alla frågor du har skapat',
    Repeatable: 'Låt användarna återta testet',
    Hide: 'Göm svaren när användaren är klar med testet',
    'Score to pass the test': 'Betyg för att klara provet',
    'Welcome message': 'Välkomstmeddelande',
    'Success message': 'Godkäntmeddelande',
    'Fail message': 'Icke godkäntmeddelande',
    threshold: 'Gräns för att klara provet (%)',
    Description: 'Beskriving av provet',
    timerInfo: 'Sätt timern i formatet TT:MM:SS'
  }
});

const styles = {
  list: {
    paddingTop: 32,
    backgroundColor: '#FFFFFF'
  },
  listHeader: {
    fontSize: 24,
    borderStyle: 'none none solid none',
    borderWidth: '1px',
    borderColor: 'rgba(0, 0, 0, 0.12)'
  }
};

const css = oxygenCss({
  header: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: 24,
    fontWeight: 500,
    lineHeight: '48px',
    paddingLeft: 16,
    borderStyle: 'none none solid none',
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.12)'
  },
  content: {
    padding: 16
  },
  buttonWrapper: {
    padding: 16
  },
  panel: {
    textAlign: 'center',
    padding: Units.keyline / 2
  },
  info: {
    padding: 16,
    // fontSize: 18,
    fontStyle: 'oblique',
    borderRadius: 3,
    border: 'solid 1px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'rgba(42, 232, 191, 0.1)'
  },
  timer: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 15,
    fontWeight: 'bold',
    marginTop: 10,
  },
});

class CourseQuizContentEditor extends mixin(RefluxMixin, Component) {
  static propTypes = {
    children: PropTypes.node,
    course: PropTypes.object,
    save: PropTypes.func,
    update: PropTypes.func,
    updateSection: PropTypes.func,
    delayedAccessSettings: PropTypes.array
  };

  constructor(props) {
    super(props);
    const { course = {} } = this.props;
    const settings = course.settings || {};
    const quizContent = settings.quiz || {};
    const { enabled, timer, isTimer } = quizContent;
    this.state = {
      enabled,
      isTimer,
      timer: timer ? timer : '00:00:00',
      repeatable: null,
    };
  }

  listenToStores() {
    this.listenToStore(CourseStore, 'courseStore');
  }

  handleChange = (e, toc, toggled) => {
    if (e.target.name === 'enabled' && !e.target.checked) {
      const ok = confirm(_l`QuizWarning`);
      if (ok) {
        this.setState({ [e.target.name]: e.target.checked });
        this.enableQuiz(toc, toggled);
      }
    } else {
      this.setState({ [e.target.name]: e.target.checked });
      this.enableQuiz(toc, toggled);
    }
  };

  save = () => {
    const { save } = this.props;
    save();
  };

  enableQuiz = (toc, enabled) => {

    const { update } = this.props;
    const hasQuiz = toc.find(s => s.type === 'quiz')
    if (!hasQuiz) {
      DashboardActions.initQuizSection(this.props.course, enabled);
    }
    this.setState({ enabled });
    update({ enabled });
    this.save();
  };

  update = (pageId, data) => {
    let quizPages = this.props.course.settings.quiz.pages || {};

    if (!Object.keys(quizPages).length) {
      quizPages = { [pageId]: { ...quizPages, ...data } };
    } else {
      quizPages[pageId]
        ? (quizPages[pageId] = { ...quizPages[pageId], ...data })
        : (quizPages = { ...quizPages, [pageId]: data });
    }

    const { update } = this.props;
    update({ pages: quizPages });
    this.save();
  };

  updateTimer = () => {
    const { update } = this.props;
    const { timer, isTimer } = this.state;

    update({timer, isTimer})
    this.save();
  }

  switchTimer = (toggled) => {
    const { update } = this.props;

    this.setState({ isTimer: toggled }, () => {
      update({ isTimer: this.state.isTimer })
      this.save();
    })
  }

  render() {
    const { course = {}, isTimer } = this.props;
    const settings = course.settings || {};
    const quizContent = settings.quiz || {};
    const { enabled } = quizContent;
    const pages = quizContent.pages || {};
    const isTimerActive = isTimer || this.state.isTimer;

    let quizGlobalSetting = (
      <List
        subheader={_l`Quiz settings`}
        style={styles.list}
        subheaderStyle={styles.listHeader}
      >
        <div className={css.buttonWrapper}>
          <Toggle
            name="enabled"
            checked={this.state.enabled}
            label={_l`Enable quiz`}
            onToggle={(event, toggled) => {
              this.handleChange(event, course.toc, toggled);
            }}
          />
          <Toggle
            name="isTimer"
            checked={this.state.isTimer}
            label={_l`Enable timer`}
            onToggle={(e, toggled) => {
              this.switchTimer(toggled);
            }}
          />
          { isTimerActive &&
            <div className={css.timer}>
              {_l`timerInfo`}
              <input type="time"
                     name="timer"
                     value={this.state.timer}
                     step="1"
                     onBlur={this.updateTimer}
                     onChange={e => this.setState({ timer: e.target.value })}/>
            </div>
          }
        </div>
      </List>
    );

    let quizToc = this.state.courseStore.course.toc.filter(
      item => item.type === 'quiz'
    );
    let quizPageSettings = null;

    if (quizToc.length && this.state.enabled) {
      quizPageSettings = quizToc[0].pages.map(item => {
        return (
          <List
            subheader={_l`Quiz page settings` + item.name}
            style={styles.list}
            subheaderStyle={styles.listHeader}
            key={item.id}
          >
            <div className={css.buttonWrapper}>
              <Toggle
                name="repeatable"
                checked={(pages[item.id] && pages[item.id].repeatable) || false}
                label={_l`Repeatable`}
                onToggle={(_, toggled) => {
                  this.update(item.id, { repeatable: toggled });
                }}
              />
              <Toggle
                name="hideanswers"
                checked={(pages[item.id] && pages[item.id].hideAnswers) || false}
                label={_l`Hide`}
                onToggle={(event, toggled) => {
                  // this.handleChange(event);
                  this.update(item.id, { hideAnswers: toggled });
                }}
              />
              {/*<TextField*/}
              {/*  type="datetime-local"*/}
              {/*  fullWidth*/}
              {/*  floatingLabelText={_l`startDate`}*/}
              {/*  onBlur={e =>*/}
              {/*    this.update(item.id, { startDate: e.target.value })*/}
              {/*  }*/}
              {/*  defaultValue={*/}
              {/*    (pages[item.id] && pages[item.id].startDate) || ' '*/}
              {/*  }*/}
              {/*/>*/}
              {/*<TextField*/}
              {/*  type="datetime-local"*/}
              {/*  fullWidth*/}
              {/*  floatingLabelText={_l`endDate`}*/}
              {/*  onBlur={e =>*/}
              {/*    this.update(item.id, { endDate: e.target.value })*/}
              {/*  }*/}
              {/*  defaultValue={*/}
              {/*    (pages[item.id] && pages[item.id].endDate) || ' '*/}
              {/*  }*/}
              {/*/>*/}
              <TextField
                fullWidth
                multiLine
                floatingLabelText={_l`Welcome message`}
                onBlur={e =>
                  this.update(item.id, { welcomeText: e.target.value })
                }
                defaultValue={
                  (pages[item.id] && pages[item.id].welcomeText) || ''
                }
              />
              <TextField
                fullWidth
                multiLine
                floatingLabelText={_l`Description`}
                onBlur={e =>
                  this.update(item.id, { descriptionText: e.target.value })
                }
                defaultValue={
                  (pages[item.id] && pages[item.id].descriptionText) || ''
                }
              />
              <TextField
                fullWidth
                multiLine
                floatingLabelText={_l`Success message`}
                onBlur={e =>
                  this.update(item.id, { successText: e.target.value })
                }
                defaultValue={
                  (pages[item.id] && pages[item.id].successText) || ''
                }
              />
              <TextField
                fullWidth
                multiLine
                floatingLabelText={_l`Fail message`}
                onBlur={e => this.update(item.id, { failText: e.target.value })}
                defaultValue={(pages[item.id] && pages[item.id].failText) || ''}
              />
              <TextField
                fullWidth
                key={item.id}
                type="number"
                floatingLabelText={_l`threshold`}
                onBlur={e =>
                  this.update(item.id, { threshold: e.target.value })
                }
                defaultValue={(pages[item.id] && pages[item.id].threshold) || 80}
              />
            </div>
          </List>
        );
      });
    }

    return (
      <span>
        {' '}
        {quizGlobalSetting}
        {quizPageSettings}{' '}
      </span>
    );
  }
}

export default connect(
  [],
  {
    update: CourseActions.updateQuizSettings,
    save: CourseActions.saveSettings
  }
)(CourseQuizContentEditor);



// WEBPACK FOOTER //
// ./src/js/containers/CourseQuizContentEditor.js